import React from 'react'
import AmbulatoryObservationsLayout from 'presentation/doctor/layouts/AmbulatoryObservations'

function AmbulatoryObservations() {
  return <AmbulatoryObservationsLayout />
}

export default AmbulatoryObservations
